// src/utils/regolePassword.js — regole uniche della password (W447)
// Stesse regole di functions/password.js: almeno 8 caratteri, non uguale all'email.
// Valgono per registrazione, invito, cambio password in Impostazioni e nuova password dal link.
export const PASSWORD_MIN = 8;

/** null se va bene, altrimenti il motivo. */
export function erroreNuovaPassword(password, email = "") {
  const p = String(password || "");
  if (p.length < PASSWORD_MIN) return `La password deve avere almeno ${PASSWORD_MIN} caratteri.`;
  if (p.length > 128) return "Password troppo lunga.";
  if (!p.trim()) return "La password non può essere fatta solo di spazi.";
  const e = String(email || "").trim().toLowerCase();
  if (e && (p.toLowerCase() === e || p.toLowerCase() === e.split("@")[0])) return "La password non può essere uguale all'email.";
  return null;
}

/** Robustezza indicativa per la barra sotto il campo: 0 debole … 3 robusta. */
export function robustezzaPassword(password) {
  const p = String(password || "");
  if (p.length < PASSWORD_MIN) return 0;
  const tipi = [/[a-z]/, /[A-Z]/, /\d/, /[^A-Za-z0-9]/].filter(r => r.test(p)).length;
  if (p.length >= 14 && tipi >= 2) return 3;
  if (p.length >= 10 && tipi >= 3) return 3;
  if (tipi >= 2) return 2;
  return 1;
}
export const ETICHETTE_ROBUSTEZZA = ["Troppo corta", "Debole", "Buona", "Robusta"];

/** Email mostrata in parte: m•••@alfaimpianti.it */
export function mascheraEmail(email) {
  const [nome, dominio] = String(email || "").split("@");
  if (!dominio) return "";
  return `${nome.slice(0, 1)}${"•".repeat(Math.max(2, Math.min(5, nome.length - 1)))}@${dominio}`;
}
